<template>
  <div class="home-banner">
    <slick ref="slick" :options="slickOptions">
      <div
        v-for="(data, index) in datas"
        :key="index"
        class="banner-wrap"
        :class="{ right: index % 2 != 0 }"
      >
        <div class="img-wrap">
          <img :src="generateImageUrl(data.image)" alt="Cover" />
        </div>
        <div class="text-info">
          <h2 class="title text-uppercase">
            {{ data.title1 }}
          </h2>
          <p class="caption">
            {{ data.title2 }}
          </p>
          <div class="custom-button with-icon">
            <a v-if="data.link" :href="data.link" target="_blank">
              Know More
              <div class="icon-wrap">
                <img src="@/assets/icons/arrow-right.svg" alt="icon" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </slick>
  </div>
</template>
<script>
import Slick from "vue-slick";

export default {
  name: "HomeBanner",
  mounted() {
    // this.$refs.slick.next();
  },
  components: {
    Slick
  },
  data() {
    return {
      slickOptions: {
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true
      }
    };
  },
  props: {
    datas: {
      type: Array,
      default: () => []
    }
  },
  // All slick methods can be used too, example here
  methods: {
    // next: function() {
    //   this.$refs.slick.next();
    // },
    // // prev: function() {
    // //   this.$refs.slick.prev();
    // // },
    // reInit: function() {
    //   // Helpful if you have to deal with v-for to update dynamic lists
    //   this.$nextTick(() => {
    //     this.$refs.slick.reSlick();
    //   });
    // }
  }
};
</script>
<style lang="scss">
@import "../../../node_modules/slick-carousel/slick/slick.css";
@import "../../../node_modules/slick-carousel/slick/slick-theme.css";

@import "@/scss/_variable.scss";
@import "@/scss/_layout.scss";

/*Slick Cara Custom*/
.slick-slider {
  margin: 0 !important;
}

.slick-track {
  display: flex;
  -webkit-align-items: center;
  align-items: center;
}

.slick-slide {
  overflow: hidden;
  img {
    margin: auto;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }
  &:focus {
    outline: none;
  }
}

.slick-list {
  margin: 0;
}

.slick-dots {
  bottom: 20px;
  li {
    width: 10px;
    height: 10px;
    button {
      position: relative;
      width: 10px;
      height: 10px;
      &:before {
        position: absolute;
        // opacity: 1 !important;
        content: "";
        width: 10px;
        height: 10px;
        top: 0;
        left: 0;
        -webkit-border-radius: 50%;
        border-radius: 50%;
        background: #de3527;
        border: 1px solid #de3527;
        opacity: 0.6;
        -webkit-transition: all 0.2s linear;
        -moz-transition: all 0.2s linear;
        -ms-transition: all 0.2s linear;
        -o-transition: all 0.2s linear;
        transition: all 0.2s linear;
      }
    }
    &.slick-active {
      width: 30px;
      button {
        &:before {
          opacity: 1;
          background: #de3527;
          border-color: #de3527;
          width: 30px;
          border-radius: 50px;
        }
      }
    }
  }
}
/*Slick css End*/

.home-banner {
  height: calc(100vh - 100px);
  max-height: 550px;
}
.banner-wrap {
  position: relative;
  height: calc(100vh - 100px);
  max-height: 550px;
  display: flex !important;
  align-items: center;
  border-radius: 10px;
  // &::before {
  //   content: "";
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   z-index: 1;
  //   width: 100%;
  //   height: 100%;
  // }
  .img-wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
  .text-info {
    padding: 50px 10%;
    position: relative;
    z-index: 1;
    max-width: 60%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background: transparent
      linear-gradient(
        90deg,
        rgba(255, 255, 255, 1) 0%,
        rgba(255, 255, 255, 0) 100%
      )
      0% 0% no-repeat padding-box;
    .title {
      font-size: 40px;
      color: #212164;
      font-weight: 800;
      letter-spacing: 1.2px;
      font-family: $content-font;
      margin-bottom: 0;
    }
    .caption {
      font-size: 16px;
      color: #000000;
      font-family: $content-font;
      font-weight: 400;
      margin: 18px 0 45px !important;
    }
    .custom-button {
      a {
        .icon-wrap {
          img {
            filter: brightness(0) invert(1);
            -webkit-transition: all 0.2s linear;
            -moz-transition: all 0.2s linear;
            -ms-transition: all 0.2s linear;
            -o-transition: all 0.2s linear;
            transition: all 0.2s linear;
          }
        }
      }
      a {
        &:hover {
          .icon-wrap {
            img {
              filter: none;
            }
          }
        }
      }
    }
  }
  &.right {
    justify-content: flex-end;
    .text-info {
      text-align: right;
      background: transparent
        linear-gradient(
          -90deg,
          rgba(255, 255, 255, 1) 0%,
          rgba(255, 255, 255, 0) 100%
        )
        0% 0% no-repeat padding-box;
      .custom-button {
        display: flex;
        justify-content: flex-end;
      }
    }
  }
}

@media only screen and (max-width: 991px) {
  .banner-wrap {
    .text-info {
      padding: 35px 8%;
      .title {
        font-size: 32px;
      }
      .caption {
        font-size: 14px;
        margin: 15px 0 40px !important;
      }
      .custom-button {
        a {
          padding: 8px 25px;
          font-size: 15px;
        }
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .banner-wrap {
    .text-info {
      padding: 30px 6%;
      max-width: 75%;
      .title {
        font-size: 28px;
      }
      .caption {
        font-size: 13px;
        line-height: 22px;
        margin: 15px 0 40px !important;
      }
      .custom-button {
        a {
          padding: 8px 25px;
          font-size: 15px;
        }
      }
    }
  }
}

@media only screen and (max-width: 575px) {
  .home-banner {
    height: calc(100vh - 225px);
  }
  .banner-wrap {
    height: calc(100vh - 225px);
    &::before {
      background: rgba(255, 255, 255, 0.6) !important;
    }
    .text-info {
      padding: 20px 10%;
      width: 100%;
      max-width: 100%;
      .title {
        text-align: center;
      }
      .caption {
        text-align: center;
        font-size: 14px;
      }
      .custom-button {
        a {
          margin: 0 auto;
        }
      }
    }
  }
}
</style>
